import type { FormValues } from "@/widgets/classic-form/form";
import { FieldComposer, fieldToConfig } from "@/features/form-fields";
import { type EventAssertion, type Field } from "@/entities/form-metadata";
import type { PrefixObjectAccessor } from "@/shared/forms";

interface EventGroupYearInputProps {
    fieldData: Field<EventAssertion>;
    fieldPath: string;
    inputProperties?: React.InputHTMLAttributes<HTMLInputElement>;
}

export const EventGroupYearInput: React.FC<EventGroupYearInputProps> = ({ fieldData, fieldPath, inputProperties }) => (
    <FieldComposer
        fieldPath={`${fieldPath}.date.year` as PrefixObjectAccessor<FormValues, []>}
        exactnessFieldPath={`${fieldPath}.dateProximity.year` as PrefixObjectAccessor<FormValues, []>}
        fieldConfig={fieldToConfig(fieldData)}
    >
        <FieldComposer.GenericField {...inputProperties} />
        <FieldComposer.GenericExactness />
    </FieldComposer>
);
